import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';
import queryString from 'query-string';

import {
  API_ENDPOINT,
  type ClientApiV1BlogsUserUserIdQueryString,
  useClientApiV1BlogsUserUserIdQuery,
} from '../../../resources/@types/uccSchema';

interface UseClientV1BlogsUserUserIdQuery {
  userId: number;
  queryParams?: ClientApiV1BlogsUserUserIdQueryString;
  options?: Parameters<typeof useClientApiV1BlogsUserUserIdQuery>[0]['options'];
}

export const DEFAULT_QUERY_PARAMS = {
  pageNumber: 1,
  pageSize: 10,
};

export const blogsUserUserIdOptions = (
  userId: number,
  queryParams?: ClientApiV1BlogsUserUserIdQueryString,
) => {
  const mergedQueryParams = { ...DEFAULT_QUERY_PARAMS, ...queryParams };

  const baseUrl = API_ENDPOINT.CLIENT_V1_BLOGS_USER_USERID(String(userId));

  const url = queryString.stringifyUrl(
    {
      url: baseUrl,
      query: mergedQueryParams,
    },
    {
      skipNull: true,
      skipEmptyString: true,
    },
  );

  const queryKey: QueryKeyReturnType = [baseUrl, mergedQueryParams];

  return {
    queryKey,
    url,
    mergedQueryParams,
  };
};

export function useBlogsUserUserIdQuery({
  userId,
  queryParams,
  options,
}: UseClientV1BlogsUserUserIdQuery) {
  const { queryKey, url } = blogsUserUserIdOptions(userId, queryParams);

  return useClientApiV1BlogsUserUserIdQuery({
    queryKey,
    url,
    options,
  });
}
